import React, { Component } from 'react';

import Popover from 'react-popover';
import cx from 'classnames';
import { Icon } from '../../../../../../../ui-kit';

import EditableComment from './EditableComment';
import Replies from './Replies';
import { checkResourceOwner } from '../../../../../utils';
import { getCurrentUserId } from '../../../../../../../common/utils';

import '../styles/_comment-popover.scss';




























class CommentPopover extends Component {
  popoverRef = React.createRef();

  constructor(props) {
    super(props);

    const editMode = props.editMode || false;

    this.state = {
      editMode,
      popoverParent: document.body
    };
  }

  componentDidMount() {
    const {
      updateViewers,
      comment: {
        commentId,
        createdByUser: {
          userId: ownerId
        },
        viewers = []
      }
    } = this.props;

    const currentUserId = getCurrentUserId();
    const existingViewer = viewers.find((viewer) => viewer.userId === currentUserId);
    const isCommentOwner = ownerId === currentUserId;

    if (currentUserId && !existingViewer && !isCommentOwner) {
      updateViewers({ commentId });
    }

    this.setState({ popoverParent: this.popoverRef.current || document.body });
  }

  onUpdateCheckbox = async () => {
    const { updateComment, comment: { isResolved, commentId } } = this.props;

    const {
      error
    } = await updateComment(commentId, { isResolved: !isResolved, disableNotifications: true });

    if (error || isResolved) {return;}

    this.toggleEditMode({ toggle: false });
  };

  toggleEditMode = ({ toggle }) => {
    const { comment: { isResolved } } = this.props;

    if (toggle && isResolved) {return;}

    this.setState({ editMode: toggle });
  };

  renderContent = () => {
    const {
      comment,
      updateComment,
      createReply,
      deleteComment,
      onDeleteComment,
      editReply,
      deleteReply,
      closePopover,
      canResolveComment,
      isReadOnly,
      resourceOrganisationId,
      resourceOwnerUserId,
      onInputFocus,
      shotId,
      sceneId
    } = this.props;

    const { editMode } = this.state;

    const isResourceOwner = checkResourceOwner(resourceOwnerUserId);

    return (
      <div className="comment-popover__container">

        <Icon
          clickable
          className="comment-popover__close-icon"
          name="close"
          onClick={closePopover}
          color="regent"
          hoverColor="black"
          size={15} />


        <div className="comment-popover__container__editable-comment-wrapper">
          <EditableComment
            onDeleteComment={onDeleteComment}
            comment={comment}
            updateComment={updateComment}
            createReply={createReply}
            closePopover={closePopover}
            deleteComment={deleteComment}
            canResolveComment={canResolveComment}
            onUpdateCheckbox={this.onUpdateCheckbox}
            editMode={editMode}
            toggleEditMode={this.toggleEditMode}
            isReadOnly={isReadOnly}
            resourceOrganisationId={resourceOrganisationId}
            isResourceOwner={isResourceOwner}
            onInputFocus={onInputFocus}
            shotId={shotId}
            sceneId={sceneId} />

        </div>

        <div className="comment-popover__container__replies-wrapper">
          <Replies
            createReply={createReply}
            editReply={editReply}
            deleteReply={deleteReply}
            closePopover={closePopover}
            comment={comment}
            isReadOnly={isReadOnly}
            resourceOrganisationId={resourceOrganisationId}
            isResourceOwner={isResourceOwner}
            onInputFocus={onInputFocus}
            shotId={shotId}
            sceneId={sceneId} />

        </div>

      </div>);

  };

  render() {
    const { children, closePopover, isV2Design } = this.props;
    const { popoverParent } = this.state;

    return (
      <div className="comment-popover__parent" ref={this.popoverRef}>
        <Popover
          {...this.props}
          key={this.popoverRef.current ? 'ready' : 'not-ready'}
          isOpen={!isV2Design}
          preferPlace="right"
          body={this.renderContent()}
          tipSize={0.01}
          onOuterAction={closePopover}
          enterExitTransitionDurationMs={0}
          className={cx('comment-popover')}
          appendTarget={popoverParent}>

          {children}
        </Popover>
      </div>);

  }
}

export default CommentPopover;